import utils from "../utils";

function init() {
	
}

window.setRate = function (button){

	var allRates = document.querySelectorAll('.woocommerce-checkout .tax-rates-select .single-rate');

	if (allRates.length > 0) {

		utils.forEach(allRates, function (index, allRate) {
			allRate.classList.remove('active');
		});

	}

	button.parentElement.classList.add('active');

	var taxRate = button.getAttribute('data-tax-rate');

	utils.setCookie('smx-tax-rate',taxRate,1440);

	jQuery(document.body).trigger('update_checkout');

}

export default { init };